import React, { useState } from "react";
import "./SearchPopup.css";

function SearchPopup({ onSearch }) {
    const [isOpen, setIsOpen] = useState(false);
    const [query, setQuery] = useState("");
    const [error, setError] = useState("");

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => {
        setIsOpen(false);
        setQuery("");
    };

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim()) {
            onSearch(query);
            handleClose();
        } else {
            setError("Please enter your keyword.");
        }
    };

    return (
        <>
            <div className="search-tooltip-wrapper">
                <button className="search-button" onClick={handleOpen}>
                    <i className="fas fa-search search-animated-icon" aria-hidden="true"></i>
                </button>
                <span className="custom-tooltip-text">Search any Services</span>
            </div>


            {isOpen && (
                <div className="search-modal-overlay" onClick={handleClose}>
                    <div className="search-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="close-btn" onClick={handleClose}>×</button>
                        <form onSubmit={handleSearch} className="formPopu">
                            <input
                                type="text"
                                placeholder="Search Keyword"
                                value={query}
                                onChange={(e) => {
                                    setQuery(e.target.value);
                                    setError("");
                                }}
                                className="modal-search-input"
                                autoFocus
                            />
                            <p>
                                {error && <p className="error-text">{error}</p>}
                                Looking for a Service? Type here…
                            </p>
                            <button type="submit" className="search-submit">SEARCH</button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}

export default SearchPopup;
